import React, { useState, useRef } from "react";
import Preloader from "./components/Preloader/Preloader";
import Navbar from "./components/Navbar/Navbar";
import Hero from "./Sections/Hero/Hero";
import Overview from "./Sections/Overview/Overview";
import Story from "./Sections/Story/Story";
import Timeline from "./Sections/Timeline/Timeline";
import Quote from "./Sections/Quote/Quote";
import Footer from "./Sections/Footer/Footer";

const App = () => {
  const [loading, setLoading] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);

  const audioRef = useRef(null);

  const handleEnterWebsite = async () => {
    if (audioRef.current) {
      try {
        await audioRef.current.play();
        setIsPlaying(true);
      } catch (error) {
        console.log("Audio did not play:", error);
      }
    }

    setLoading(false);
  };

  const toggleMusic = async () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    } else {
      try {
        await audioRef.current.play();
        setIsPlaying(true);
      } catch (error) {
        console.log("Audio did not play:", error);
      }
    }
  };

  return (
    <div className="app">
      <Preloader isLoading={loading} onEnter={handleEnterWebsite} />

      <audio ref={audioRef} loop>
        <source src="/assets/audio/fairuz.mp3" type="audio/mpeg" />
      </audio>

      {!loading && (
        <>
          <div className="page">
            <Navbar
              isPlaying={isPlaying}
              onToggleMusic={toggleMusic}
            />

            <Hero />
            <Overview />
            <Story />
            <Timeline />
            <Quote />
            <Footer />
          </div>

          <div className="not-responsive-message">
            This website is designed for desktop view only.
          </div>
        </>
      )}
    </div>
  );
};

export default App;